import React from 'react';
import { MapPin, Award, Zap, Smile } from 'lucide-react';
const features = [{
  title: 'Local Expertise',
  description: 'Serving Southern Maryland with care and attention to detail.',
  icon: MapPin
}, {
  title: 'Quality Craftsmanship',
  description: 'We use professional-grade equipment and materials to ensure your custom gear looks amazing.',
  icon: Award
}, {
  title: 'Fast Turnaround',
  description: 'We work hard to get your order to you quickly without compromising on quality.',
  icon: Zap
}, {
  title: 'Personalized Service',
  description: 'Real people, real help. We guide you through the design process from start to finish.',
  icon: Smile
}];
export function WhyChooseUs() {
  return <section className="py-20 bg-purple-900 text-white relative overflow-hidden" data-id="element-272">
      {/* Background pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-273">
        <svg className="h-full w-full" width="100%" height="100%" viewBox="0 0 800 800" data-id="element-274">
          <defs data-id="element-275">
            <pattern id="grid-pattern" width="40" height="40" patternUnits="userSpaceOnUse" data-id="element-276">
              <circle cx="2" cy="2" r="1" fill="currentColor" data-id="element-277" />
            </pattern>
          </defs>
          <rect width="100%" height="100%" fill="url(#grid-pattern)" data-id="element-278" />
        </svg>
      </div>

      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 relative z-10" data-id="element-279">
        <div className="text-center mb-16" data-id="element-280">
          <h2 className="text-3xl md:text-4xl font-bold mb-4" data-id="element-281">
            Why Choose Teams 'n Tees?
          </h2>
          <p className="text-purple-200 text-lg max-w-2xl mx-auto" data-id="element-282">
            We're more than just a print shop. We're your partners in creating
            something special.
          </p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8" data-id="element-283">
          {features.map(feature => <div key={feature.title} className="bg-purple-800/50 backdrop-blur-sm p-8 rounded-xl border border-purple-700/50 hover:bg-purple-800 transition-colors" data-id="element-284">
              <div className="h-12 w-12 bg-teal-500 rounded-lg flex items-center justify-center text-white mb-6 shadow-lg" data-id="element-285">
                <feature.icon className="h-6 w-6" data-id="element-286" />
              </div>
              <h3 className="text-xl font-bold mb-3" data-id="element-287">{feature.title}</h3>
              <p className="text-purple-100 leading-relaxed" data-id="element-288">
                {feature.description}
              </p>
            </div>)}
        </div>
      </div>
    </section>;
}